import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo, useState } from 'react';
import * as LucideIcons from 'lucide-react';
import { CUSTOM_TILE_ICONS, iconMatchesQuery, normalizeSearch } from '../../lib/customTileIcons';
/** Resolve a Lucide icon name to its component, falling back to LayoutGrid. */
export function resolveIcon(name) {
    const icons = LucideIcons;
    return icons[name] ?? icons.LayoutGrid;
}
export function IconPicker({ value, color, onChange }) {
    const [search, setSearch] = useState('');
    const icons = useMemo(() => {
        const q = normalizeSearch(search);
        const unique = Array.from(new Set(CUSTOM_TILE_ICONS));
        if (!q)
            return unique;
        return unique.filter((name) => iconMatchesQuery(name, q));
    }, [search]);
    return (_jsxs("div", { children: [_jsx("input", { value: search, onChange: (e) => setSearch(e.target.value), placeholder: "Rechercher une ic\u00F4ne\u2026", className: "w-full px-3 py-2 border rounded-lg text-sm mb-2" }), _jsxs("div", { className: "grid grid-cols-8 gap-1.5 max-h-56 overflow-y-auto p-1 border rounded-lg bg-gray-50", children: [icons.map((name) => {
                        const Icon = resolveIcon(name);
                        const selected = name === value;
                        return (_jsx("button", { type: "button", title: name, onClick: () => onChange(name), className: `aspect-square flex items-center justify-center rounded-lg border-2 transition-colors ${selected ? 'border-gray-800 bg-white' : 'border-transparent hover:bg-white'}`, children: _jsx(Icon, { size: 20, color: selected ? color : '#6B7280' }) }, name));
                    }), icons.length === 0 && (_jsx("p", { className: "col-span-8 text-sm text-gray-400 py-4 text-center", children: "Aucune ic\u00F4ne." }))] })] }));
}
